<div class="od-root od-ficha" *ngIf="{ p: pestana$ | async, oc: ocupado$ | async, res: resultado$ | async, conf: confirmar$ | async } as s">
  <button type="button" class="od-btn" (click)="volver()"><span aria-hidden="true">←</span> Volver al perfil</button>

  <ng-container *ngIf="ficha$ | async as v">
    <!-- Error de carga -->
    <div class="od-alert" role="alert" style="margin-top: 14px" *ngIf="v.error && !v.datos">
      <od-icon name="alert" [size]="16"></od-icon>
      <div class="od-alert-tx"><b>No se pudo abrir la gestión en Odoo</b><div class="od-muted">{{ v.error }}</div></div>
      <button type="button" class="od-btn" (click)="recargar()"><od-icon name="refresh"></od-icon>Reintentar</button>
    </div>

    <!-- Cargando por primera vez -->
    <div *ngIf="v.cargando && !v.datos" aria-busy="true" aria-label="Cargando la gestión en Odoo" style="margin-top: 14px">
      <div class="od-skeleton" style="height: 30px; width: 60%; margin-bottom: 12px"></div>
      <div class="od-skeleton" style="height: 38px; width: 340px; max-width: 100%; margin-bottom: 12px"></div>
      <div class="od-skeleton" style="height: 44px; margin-bottom: 8px"></div>
      <div class="od-skeleton" style="height: 38px; margin-bottom: 6px" *ngFor="let i of esperaSkeleton; trackBy: porFila"></div>
    </div>

    <ng-container *ngIf="v.datos as d">
      <!-- Cabecera -->
      <header class="od-ficha-cab">
        <h1><od-icon name="link" [size]="22"></od-icon>Gestión en Odoo</h1>
        <span class="od-muted">{{ d.f.cliente.nombre || 'Cliente' }}<ng-container *ngIf="d.f.cliente.identificacion"> · <span class="od-mono">{{ d.f.cliente.identificacion }}</span></ng-container></span>
        <span class="od-chip">Código en Odoo: <b>{{ d.f.odoo.odoo_id ?? '—' }}</b></span>
        <span class="od-badge od-badge-solid" *ngIf="d.f.odoo.en_odoo"><od-icon name="check"></od-icon>Anotado en Odoo</span>
        <span class="od-badge" *ngIf="!d.f.odoo.en_odoo"><od-icon name="clock"></od-icon>Todavía no está en Odoo</span>
        <span class="od-badge od-badge-problem" *ngIf="d.f.odoo.estado_ui === 'problema'"><od-icon name="alert"></od-icon>Con problema</span>
      </header>
      <p class="od-ficha-fechas" *ngIf="d.f.odoo.en_odoo">
        <span>Anotado el <b>{{ d.f.odoo.fe_alta | odooDiaLargo }}</b> · {{ d.f.odoo.fe_alta | odooHoraSola }}</span>
        <span>Última modificación: <b>{{ d.f.odoo.fe_ultima_modif ? (d.f.odoo.fe_ultima_modif | odooDiaLargo) : '—' }}</b><ng-container *ngIf="d.f.odoo.fe_ultima_modif"> · {{ d.f.odoo.fe_ultima_modif | odooHoraSola }}</ng-container></span>
      </p>

      <!-- Pestañas -->
      <div class="od-tabs" role="tablist" aria-label="Gestión en Odoo" style="margin-top: 14px">
        <button type="button" class="od-tab" role="tab" *ngFor="let t of pestanas; trackBy: porId"
                [id]="'od-ficha-tab-' + t.id" [attr.aria-selected]="s.p === t.id" aria-controls="od-ficha-panel"
                [attr.tabindex]="s.p === t.id ? 0 : -1" (click)="irA(t.id)" (keydown)="teclas($event, $any(s.p))">
          <od-icon [name]="t.icono"></od-icon><span>{{ t.texto }}</span>
        </button>
      </div>

      <!-- Resultado de la última acción -->
      <div class="od-alert" *ngIf="s.res as r" [attr.role]="r.exito ? 'status' : 'alert'" [class.od-alert-flat]="r.exito">
        <od-icon [name]="r.exito ? 'check' : 'alert'" [size]="16"></od-icon>
        <div class="od-alert-tx">
          <b>{{ titulo(r) }}</b>
          <div class="od-muted">{{ r.mensaje }}</div>
          <ul class="od-lista" *ngIf="r.faltantes?.length"><li *ngFor="let x of r.faltantes; trackBy: porTexto">{{ x }}</li></ul>
        </div>
        <button type="button" class="od-btn" *ngIf="!r.exito && r.reintentable && s.p !== 'revisar'" [disabled]="!!s.oc" (click)="reintentar()"><od-icon name="refresh"></od-icon>Volver a intentar</button>
        <button type="button" class="od-btn od-btn-sm" aria-label="Cerrar este aviso" (click)="cerrarResultado()">Cerrar</button>
      </div>

      <!-- Avisos generales -->
      <div class="od-alert od-alert-flat" role="status" *ngIf="!d.f.integracion.activa">
        <od-icon name="alert" [size]="16"></od-icon>
        <div class="od-alert-tx"><b>La integración con Odoo está apagada.</b> <span class="od-muted">Puedes revisar al cliente, pero no enviarlo hasta que quien la administra la active.</span></div>
      </div>
      <div class="od-alert od-alert-flat" role="status" *ngIf="d.f.odoo.estado_ui === 'problema' && d.f.odoo.motivo">
        <od-icon name="alert" [size]="16"></od-icon>
        <div class="od-alert-tx"><b>El último envío no salió bien.</b> <span class="od-muted">{{ d.f.odoo.motivo }}</span></div>
      </div>
      <div class="od-alert od-alert-flat" role="status" *ngIf="!d.f.odoo.en_odoo && d.f.odoo.reintento_automatico">
        <od-icon name="clock" [size]="16"></od-icon>
        <div class="od-alert-tx"><b>Hay un envío esperando.</b> <span class="od-muted">Se vuelve a intentar solo cada hora; también puedes anotarlo ahora.</span></div>
      </div>

      <div class="od-seccion" id="od-ficha-panel" role="tabpanel" tabindex="0" [attr.aria-labelledby]="'od-ficha-tab-' + s.p" [attr.aria-busy]="!!s.oc">
        <!-- ═════ REVISAR ═════ -->
        <ng-container *ngIf="s.p === 'revisar'">
          <div class="od-alert od-alert-flat" role="status" style="border-width: 1.5px" *ngIf="d.f.revision.cumple">
            <od-icon name="check" [size]="18"></od-icon>
            <div class="od-alert-tx"><b>Cumple lo que Odoo pide</b> <span class="od-muted">{{ d.f.odoo.en_odoo ? 'y sus datos están listos para enviarse.' : 'y está lista para anotarse.' }}</span></div>
          </div>
          <div class="od-alert" role="alert" *ngIf="!d.f.revision.cumple">
            <od-icon name="alert" [size]="18"></od-icon>
            <div class="od-alert-tx">
              <b>Falta lo siguiente para poder enviarla a Odoo</b>
              <ul class="od-lista"><li *ngFor="let x of d.f.revision.faltantes; trackBy: porTexto">{{ x }}</li></ul>
            </div>
          </div>
          <p class="od-note" *ngFor="let a of d.f.revision.avisos; trackBy: porTexto">{{ a }}</p>

          <h5 class="od-sec-t" style="font-size: 14px; font-weight: 600; margin: 14px 0 6px">Datos que se enviarían a Odoo</h5>
          <div class="od-table-wrap">
            <table class="od-table od-ficha-datos">
              <caption style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0)">Datos del cliente que se enviarían a Odoo</caption>
              <tbody>
                <tr *ngFor="let fila of d.filas; trackBy: porFila">
                  <th scope="row">{{ fila.a.etiqueta }}</th>
                  <td>{{ fila.a.valor }}<span class="od-ficha-nota" *ngIf="fila.a.nota">({{ fila.a.nota }})</span></td>
                  <ng-container *ngIf="fila.b as b">
                    <th scope="row">{{ b.etiqueta }}</th>
                    <td>{{ b.valor }}<span class="od-ficha-nota" *ngIf="b.nota">({{ b.nota }})</span></td>
                  </ng-container>
                  <ng-container *ngIf="!fila.b"><th></th><td></td></ng-container>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="od-ficha-pie">
            <span class="od-ficha-motivo" id="od-ficha-m-anotar" *ngIf="!d.f.acciones.anotar.puede">{{ d.f.acciones.anotar.motivo }}</span>
            <button type="button" class="od-btn" [disabled]="!!s.oc" (click)="revisar()">
              <od-icon name="refresh" [ngClass]="{ 'od-spin': s.oc === 'revisar' }"></od-icon>{{ s.oc === 'revisar' ? 'Revisando…' : 'Volver a revisar' }}
            </button>
            <button type="button" class="od-btn od-btn-primary" *ngIf="puedeEscribir" aria-describedby="od-ficha-m-anotar"
                    [disabled]="!d.f.acciones.anotar.puede || !!s.oc" (click)="pedirConfirmacion('anotar')">
              <od-icon name="upload"></od-icon>Anotar en Odoo
            </button>
          </div>
        </ng-container>

        <!-- ═════ ANOTAR ═════ -->
        <ng-container *ngIf="s.p === 'anotar'">
          <div class="od-card">
            <h5 class="od-card-title">Dar de alta al cliente en Odoo</h5>
            <p class="od-muted">Úsalo cuando el aviso automático no salió. Se envían los datos que ves en «Revisar». Si Odoo ya tenía a este cliente, no pasa nada: queda anotado y se actualizan sus datos.</p>
            <p style="margin-top: 10px" *ngIf="d.f.odoo.en_odoo">
              <span class="od-badge od-badge-solid"><od-icon name="check"></od-icon>Anotado en Odoo</span>
              <span class="od-muted"> el {{ d.f.odoo.fe_alta | odooDiaLargo }}. Para corregir sus datos usa «Actualizar».</span>
            </p>
            <div class="od-ficha-pie">
              <span class="od-ficha-motivo" id="od-ficha-m-anotar2" *ngIf="!d.f.acciones.anotar.puede && !d.f.odoo.en_odoo">{{ d.f.acciones.anotar.motivo }}</span>
              <span class="od-ficha-motivo" *ngIf="!puedeEscribir">No tienes permiso para anotar clientes en Odoo.</span>
              <button type="button" class="od-btn od-btn-primary" aria-describedby="od-ficha-m-anotar2"
                      [disabled]="!puedeEscribir || !d.f.acciones.anotar.puede || !!s.oc" (click)="pedirConfirmacion('anotar')">
                <od-icon [name]="s.oc === 'anotar' ? 'refresh' : 'upload'" [ngClass]="{ 'od-spin': s.oc === 'anotar' }"></od-icon>{{ s.oc === 'anotar' ? 'Anotando…' : 'Anotar en Odoo' }}
              </button>
            </div>
          </div>
        </ng-container>

        <!-- ═════ ACTUALIZAR ═════ -->
        <ng-container *ngIf="s.p === 'actualizar'">
          <div class="od-empty od-card" *ngIf="!d.f.odoo.en_odoo">
            <od-icon name="clock" [size]="22"></od-icon>
            <b>Este cliente todavía no está en Odoo</b>
            <span>Primero anótalo; después podrás corregir su correo o teléfonos aquí.</span>
            <button type="button" class="od-btn" style="margin-top: 8px" (click)="irA('anotar')">Ir a «Anotar»</button>
          </div>

          <form *ngIf="d.f.odoo.en_odoo" [formGroup]="form" (ngSubmit)="pedirConfirmacion('actualizar')" novalidate>
            <p class="od-muted" style="margin-bottom: 8px">Corrige el correo o los teléfonos y envíalos a Odoo. El nombre y la cédula no se cambian aquí.</p>
            <div class="od-ficha-form">
              <div class="od-campo">
                <label for="od-f-nombre">Nombre</label>
                <span class="od-input od-input-lock"><od-icon name="lock"></od-icon><input id="od-f-nombre" type="text" readonly aria-readonly="true" [value]="d.f.cliente.nombre || '—'"></span>
              </div>
              <div class="od-campo">
                <label for="od-f-cedula">Cédula</label>
                <span class="od-input od-input-lock"><od-icon name="lock"></od-icon><input id="od-f-cedula" type="text" readonly aria-readonly="true" [value]="d.f.cliente.identificacion || '—'"></span>
              </div>
              <div class="od-campo od-ancho">
                <label for="od-f-email">Correo</label>
                <span class="od-input" [class.od-invalido]="campoInvalido('email')"><od-icon name="edit"></od-icon>
                  <input id="od-f-email" type="email" formControlName="email" autocomplete="off" maxlength="120" placeholder="nombre@correo.com"
                         [attr.aria-invalid]="campoInvalido('email')" aria-describedby="od-f-email-ayuda"></span>
                <div class="od-error" id="od-f-email-ayuda" *ngIf="campoInvalido('email')" role="alert"><od-icon name="alert"></od-icon>El correo no tiene un formato válido (ej. nombre@correo.com).</div>
              </div>
              <div class="od-campo">
                <label for="od-f-tel">Teléfono</label>
                <span class="od-input" [class.od-invalido]="campoInvalido('telefono')"><od-icon name="edit"></od-icon>
                  <input id="od-f-tel" type="tel" formControlName="telefono" autocomplete="off" maxlength="30" placeholder="0414 111 2233"
                         [attr.aria-invalid]="campoInvalido('telefono')" aria-describedby="od-f-tel-ayuda"></span>
                <div class="od-error" id="od-f-tel-ayuda" *ngIf="campoInvalido('telefono')" role="alert"><od-icon name="alert"></od-icon>El teléfono no es válido (ej. 0414 111 2233).</div>
              </div>
              <div class="od-campo">
                <label for="od-f-tel2">Otro teléfono</label>
                <span class="od-input" [class.od-invalido]="campoInvalido('otro_telefono')"><od-icon name="edit"></od-icon>
                  <input id="od-f-tel2" type="tel" formControlName="otro_telefono" autocomplete="off" maxlength="30" placeholder="0424 777 3321"
                         [attr.aria-invalid]="campoInvalido('otro_telefono')" aria-describedby="od-f-tel2-ayuda"></span>
                <div class="od-error" id="od-f-tel2-ayuda" *ngIf="campoInvalido('otro_telefono')" role="alert"><od-icon name="alert"></od-icon>El teléfono no es válido (ej. 0424 777 3321).</div>
              </div>
              <p class="od-ayuda od-ancho od-soft" style="margin: 0; font-size: 12px">Odoo guarda un solo teléfono: se envía el principal y, si lo dejas vacío, el otro. Lo que dejes vacío no se cambia en Odoo. Los datos del cliente en CrediTotal no se modifican desde aquí.</p>
            </div>
            <div class="od-ficha-pie">
              <span class="od-ficha-motivo" id="od-ficha-m-act" *ngIf="!puedeEscribir">No tienes permiso para actualizar clientes en Odoo.</span>
              <span class="od-ficha-motivo" id="od-ficha-m-act" *ngIf="puedeEscribir && !d.f.acciones.actualizar.puede">{{ d.f.acciones.actualizar.motivo }}</span>
              <button type="button" class="od-btn" [disabled]="!hayCambios || !!s.oc" (click)="descartar()">Descartar cambios</button>
              <button type="submit" class="od-btn od-btn-primary" aria-describedby="od-ficha-m-act"
                      [disabled]="!puedeEscribir || !d.f.acciones.actualizar.puede || !hayCambios || form.invalid || !!s.oc">
                <od-icon [name]="s.oc === 'actualizar' ? 'refresh' : 'upload'" [ngClass]="{ 'od-spin': s.oc === 'actualizar' }"></od-icon>{{ s.oc === 'actualizar' ? 'Guardando…' : 'Guardar cambios en Odoo' }}
              </button>
            </div>
          </form>
        </ng-container>

        <!-- ═════ HISTORIAL ═════ -->
        <ng-container *ngIf="s.p === 'historial'">
          <ng-container *ngIf="movs$ | async as m">
            <div class="od-toolbar">
              <span class="od-muted">Cada vez que se revisa, anota o actualiza a este cliente queda una línea.</span>
              <button type="button" class="od-btn od-btn-sm od-fin" style="margin-left: auto" [disabled]="m.cargando" (click)="recargarHistorial()"><od-icon name="refresh"></od-icon>Actualizar</button>
            </div>
            <div class="od-alert" role="alert" *ngIf="m.error">
              <od-icon name="alert" [size]="16"></od-icon>
              <div class="od-alert-tx"><b>No se pudo traer el historial</b><div class="od-muted">{{ m.error }}</div></div>
              <button type="button" class="od-btn" (click)="recargarHistorial()"><od-icon name="refresh"></od-icon>Reintentar</button>
            </div>
            <div *ngIf="m.cargando && !m.datos" aria-busy="true" aria-label="Cargando el historial">
              <div class="od-skeleton" style="height: 38px; margin-bottom: 6px" *ngFor="let i of esperaSkeleton; trackBy: porFila"></div>
            </div>
            <div class="od-empty od-card" *ngIf="m.datos && !m.datos.length">
              <od-icon name="history" [size]="22"></od-icon>
              <b>Todavía no hay movimientos de este cliente</b>
              <span>Aparecen aquí cuando se revisa, se anota o se actualiza en Odoo.</span>
            </div>
            <div class="od-table-wrap" *ngIf="m.datos && m.datos.length" [style.opacity]="m.cargando ? .6 : 1">
              <table class="od-table">
                <caption style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0)">Movimientos de este cliente en Odoo, del más reciente al más antiguo</caption>
                <thead><tr><th scope="col">Fecha</th><th scope="col">Acción</th><th scope="col">Resultado</th><th scope="col">Usuario</th><th scope="col"><span style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0)">Datos técnicos</span></th></tr></thead>
                <tbody>
                  <ng-container *ngFor="let e of m.datos; trackBy: porMov">
                    <tr>
                      <td>{{ e.fecha | odooDiaLargo }} · {{ e.fecha | odooHoraSola }}</td>
                      <td>{{ e.accion_texto }}</td>
                      <td>
                        <span class="od-badge od-badge-solid" *ngIf="e.ok"><od-icon name="check"></od-icon>Bien</span>
                        <span class="od-badge od-badge-problem" *ngIf="!e.ok"><od-icon name="alert"></od-icon>Con problema</span>
                        <div class="od-muted" style="font-size: 12px; margin-top: 2px" *ngIf="!e.ok && e.motivo">{{ e.motivo }}</div>
                      </td>
                      <td>{{ e.usuario }}</td>
                      <td style="text-align: right">
                        <button type="button" class="od-btn od-btn-sm" [attr.aria-expanded]="verTecnico.has(e.id)" [attr.aria-controls]="'od-tec-' + e.id" (click)="alternarTecnico(e.id)">
                          {{ verTecnico.has(e.id) ? 'Ocultar datos técnicos' : 'Ver datos técnicos' }}
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="verTecnico.has(e.id)"><td colspan="5" [id]="'od-tec-' + e.id"><pre class="od-tecnico od-mono" tabindex="0">{{ tecnicoTexto(e) }}</pre></td></tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- Confirmación -->
      <div class="od-dialog-fondo" *ngIf="s.conf as c" (click)="cerrarConfirmacion()">
        <div #dlg class="od-dialog" role="dialog" aria-modal="true" aria-labelledby="od-ficha-conf-t" (click)="$event.stopPropagation()" (keydown)="atrapar($event, dlg)">
          <ng-container *ngIf="c === 'anotar'">
            <h4 id="od-ficha-conf-t" style="font-size: 16px; font-weight: 700">¿Anotar a {{ d.f.cliente.nombre || 'este cliente' }} en Odoo?</h4>
            <p class="od-muted" style="font-size: 13px; margin-top: 8px">Se le avisará a Odoo ahora con los datos de «Revisar». Si Odoo ya lo tenía, quedará anotado y se actualizarán sus datos. Queda registrado en el Historial.</p>
          </ng-container>
          <ng-container *ngIf="c === 'actualizar'">
            <h4 id="od-ficha-conf-t" style="font-size: 16px; font-weight: 700">¿Enviar estos cambios a Odoo?</h4>
            <ul class="od-lista" style="font-size: 13px; margin-top: 8px"><li *ngFor="let x of cambiosParaMostrar(); trackBy: porFila"><b>{{ x.etiqueta }}:</b> {{ x.valor }}</li></ul>
            <p class="od-muted" style="font-size: 13px; margin-top: 8px">Solo cambian en Odoo. Queda registrado en el Historial.</p>
          </ng-container>
          <div class="od-dialog-pie">
            <button type="button" class="od-btn" id="od-ficha-conf-cancelar" (click)="cerrarConfirmacion()">Cancelar</button>
            <button type="button" class="od-btn od-btn-primary" (click)="confirmarAccion()">{{ c === 'anotar' ? 'Sí, anotar en Odoo' : 'Sí, enviar a Odoo' }}</button>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
